<div class="app-container app-theme-white body-tabs-shadow">
    <div class="app-container">
        <div class="h-100">
            <div class="h-100 no-gutters row">
                <div class="d-none d-lg-block col-lg-5">

                    <div class="slider-light">

                        <div class="slick-slider h-100">
                            <div>
                                <div
                                    class="position-relative h-100 d-flex justify-content-center align-items-center bg-plum-plate">
                                    <div class="slide-img-bg"
                                        style="background-image: url('assets/images/Cust-login.png');"></div>
                                    <div class="slider-content">
                                        <h3>Welcome to Customer Portal</h3>
                                        <p>Designed exclusively for you—offering real-time project updates, dedicated service and support, and AI-driven assistance at your fingertips.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-100 d-flex bg-white justify-content-center align-items-center col-md-12 col-lg-7">
                    <div class="mx-auto app-login-box col-sm-12 col-md-10 col-lg-9">
                        <div>
                            <img src="../../../assets/images/LogicAbsolute-logo-512x512.png" alt="Logic Absolute Logo" height="170px">
                        </div>
                        <h4 class="mb-0">
                            <span class="d-block">Welcome back,</span>
                            <span>Please sign in to your account.</span>
                        </h4>
                        <div class="divider row"></div>
                        <div>
                            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                                <div class="form-row">
                                    <div class="col-md-6">
                                        <div class="position-relative form-group">
                                            <label for="exampleEmail" class="">User Name</label>
                                            <input name="email" id="exampleEmail" formControlName="emailId"
                                                placeholder="User Name" type="email" class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && loginForm.controls['emailId'].errors }">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="position-relative form-group">
                                            <label for="examplePassword" class="">Password</label>
                                            <input name="password" id="examplePassword" formControlName="password"
                                                placeholder="Password here..." type="password" class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && loginForm.controls['password'].errors }">
                                        </div>
                                    </div>
                                </div>
                                <div class="divider row"></div>
                                <div class="d-flex align-items-center">
                                    <div class="ml-auto">
                                        <a href="javascript:void(0);" (click)="recoverPassword()"
                                            class="btn-lg btn btn-link">Recover Password</a>
                                        <button class="btn btn-primary btn-lg" (click)="onSubmit()"
                                            [disabled]="submitted || loginForm.controls['emailId'].errors || loginForm.controls['password'].errors">Login to
                                            Dashboard</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>